import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/authSlice';
import { useAppSettings } from '../hooks/useAppSettings';

const navItems = [
  { path: '/user/dashboard', icon: '🏠', label: 'Dashboard' },
  { path: '/user/apply', icon: '📝', label: 'Apply NOC' },
  { path: '/user/applications', icon: '📋', label: 'My Applications' },
  { path: '/user/notifications', icon: '🔔', label: 'Notifications' },
  { path: '/user/download', icon: '⬇️', label: 'Download NOC' },
  { path: '/user/profile', icon: '👤', label: 'My Profile' },
  { path: '/user/feedback', icon: '📝', label: 'Feedback' },
];

export default function CitizenLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useSelector(s => s.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const settings = useAppSettings();
  const handleLogout = () => { dispatch(logout()); navigate('/citizen-login'); };

  const headerColor = settings?.header_color || '#1a365d';

  return (
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: settings?.bg_color || '#f7fafc' }}>
      <aside className={`fixed inset-y-0 left-0 z-40 w-64 transform transition-transform duration-300 lg:static lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ background: `linear-gradient(180deg, ${headerColor} 0%, ${headerColor}cc 100%)` }}>
        <div className="flex flex-col h-full">
          <div className="px-6 py-5 border-b border-white/10" style={{ background: headerColor }}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-xl">🏛️</div>
              <div>
                <p className="text-white font-bold text-sm leading-tight truncate max-w-[140px]">
                  {settings?.app_name || 'Gov NOC Portal'}
                </p>
                <p className="text-white/70 text-xs">Citizen Panel</p>
              </div>
            </div>
          </div>
          <div className="px-4 py-3 border-b border-white/10">
            <p className="text-xs text-white/60">Logged in as</p>
            <p className="text-white font-medium text-sm truncate">{user?.name || user?.mobile}</p>
          </div>
          <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
            {navItems.map(item => (
              <NavLink key={item.path} to={item.path}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
          <div className="p-3 border-t border-white/10">
            <button onClick={handleLogout} className="sidebar-link w-full text-left">
              <span>🚪</span><span>Logout</span>
            </button>
          </div>
        </div>
      </aside>
      {sidebarOpen && <div className="fixed inset-0 z-30 bg-black/50 lg:hidden" onClick={() => setSidebarOpen(false)} />}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-4 shadow-sm">
          <button className="lg:hidden text-gray-500 text-xl" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
          <h2 className="text-gray-700 font-semibold text-sm flex-1">
            {settings?.app_name || 'Government NOC Management System'}
          </h2>
          <span className="text-xs text-green-700 bg-green-50 border border-green-200 px-3 py-1 rounded-full">Citizen</span>
        </header>
        <main className="flex-1 overflow-y-auto p-4 md:p-6"><Outlet /></main>
      </div>
    </div>
  );
}